import { useState } from 'react'
import { motion } from 'framer-motion'

const ACCENT = {
  'Inventory Sync': 'rgba(235,23,0,0.7)',
  'Account Benchmarking': 'rgba(235,23,0,0.7)',
}

const activities = [
  { label: 'Inventory Sync', title: 'J&J agent completed overnight par review for Mercy General', description: 'Last sync: 11:53 PM. 4 items flagged, brief compiled.' },
  { label: 'Schedule Confirmation', title: 'Agent sent case count request for week of Aug 3', description: 'Awaiting response from OR coordinator' },
  { label: 'Inventory Sync', title: 'J&J agent completed overnight par review for Mercy General', description: 'Last sync: 11:53 PM. 0 items flagged, brief compiled.' },
  { label: 'Account Benchmarking', title: 'J&J agent retrieved retractor consumption data from 3 comparable accounts', description: 'Available in Demand Sensing report. Flagged for FLR02 anomaly review.' },
  { label: 'Schedule Confirmation', title: 'Agent sent case count request for week of Aug 10', description: 'Awaiting response from OR coordinator' },
  { label: 'Schedule Confirmation', title: 'Agent sent case count request for week of Aug 17', description: 'Awaiting response from OR coordinator' },
  { label: 'Schedule Confirmation', title: 'Agent sent confirmation request to OR for schedule', description: 'Awaiting response from nursing manager.' },
  { label: 'Schedule Confirmation', title: 'Agent sent case count request for week of Aug 24', description: 'Awaiting response from OR coordinator' },
]

export default function ActivityFeedPanel() {
  return (
    <div style={{
      width: '100%', flex: 1,
      padding: 16, display: 'flex',
      flexDirection: 'column', gap: 8, overflow: 'hidden',
    }}>
      {/* Header */}
      <motion.div
        initial={{ opacity: 0 }} animate={{ opacity: 1 }}
        transition={{ delay: 0.6, duration: 0.4 }}
        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: 28, flexShrink: 0 }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span style={labelStyle}>All Agent Activity</span>
          <CounterBadge target={24} delay={1.2} />
        </div>
        <ChevronBtn />
      </motion.div>

      {/* Feed with scroll fade */}
      <div style={{ position: 'relative', flex: 1, minHeight: 0 }}>
        <div style={{ height: '100%', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 6 }} className="feed-scroll">
          {activities.map((item, i) => (
            <ActivityCard key={i} item={item} index={i} />
          ))}
        </div>
        {/* Scroll fade */}
        <div style={{
          position: 'absolute', bottom: 0, left: 0, right: 0, height: 48,
          background: 'linear-gradient(to bottom, transparent, rgba(0,0,0,0.45))',
          pointerEvents: 'none', borderRadius: '0 0 4px 4px',
        }} />
      </div>
    </div>
  )
}

function ActivityCard({ item, index }) {
  const [hovered, setHovered] = useState(false)
  const accentColor = ACCENT[item.label] || 'rgba(255,255,255,0.22)'

  return (
    <motion.div
      initial={{ opacity: 0, x: 16 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1], delay: 0.8 + index * 0.07 }}
      whileHover={{ x: 4, transition: { duration: 0.18 } }}
      onHoverStart={() => setHovered(true)}
      onHoverEnd={() => setHovered(false)}
      style={{
        background: 'rgba(0,0,0,0.1)', borderRadius: 4, padding: '9px 12px',
        display: 'flex', flexDirection: 'column', gap: 1,
        flexShrink: 0, cursor: 'default', position: 'relative', overflow: 'hidden',
      }}
    >
      {/* Left accent line */}
      <motion.div
        animate={{ scaleY: hovered ? 1 : 0, opacity: hovered ? 1 : 0 }}
        transition={{ duration: 0.18 }}
        style={{
          position: 'absolute', left: 0, top: 4, bottom: 4, width: 2,
          background: accentColor, borderRadius: 1, transformOrigin: 'center',
        }}
      />
      <span style={labelStyle}>{item.label}</span>
      <span style={{ fontSize: 12, fontWeight: 700, color: '#FFFFFF', lineHeight: 1.4 }}>{item.title}</span>
      <span style={{ fontSize: 12, fontWeight: 400, color: '#D5CFC9', lineHeight: 1.4 }}>{item.description}</span>
    </motion.div>
  )
}

function CounterBadge({ target, delay }) {
  return (
    <motion.span
      initial={{ opacity: 0 }} animate={{ opacity: 1 }}
      transition={{ delay, duration: 0.4 }}
      style={{ fontSize: 10, fontWeight: 700, color: '#F8F8F7', background: 'rgba(255,255,255,0.1)', borderRadius: 3, padding: '1px 6px' }}
    >
      {target}
    </motion.span>
  )
}

// #1 — chevron rotates on hover via variant propagation
const chevronBtnVariants = { rest: { scale: 1 }, hover: { scale: 1.15 } }
const chevronIconVariants = { rest: { rotate: 0 }, hover: { rotate: 180 } }

function ChevronBtn() {
  return (
    <motion.button
      variants={chevronBtnVariants} initial="rest" whileHover="hover"
      transition={{ duration: 0.25 }}
      style={{ width: 28, height: 28, borderRadius: 8, background: 'transparent', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <motion.svg variants={chevronIconVariants} transition={{ duration: 0.25 }} width="10" height="6" viewBox="0 0 10 6" fill="none">
        <path d="M1 1L5 5L9 1" stroke="#A39992" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </motion.svg>
    </motion.button>
  )
}

const labelStyle = { fontSize: 10, fontWeight: 700, color: '#A39992', textTransform: 'uppercase', letterSpacing: '0.09em' }
